// extracted by mini-css-extract-plugin
export var card = "card-module--card--b237b";
export var shadow = "card-module--shadow--2e63a";